<script setup lang="ts">
	const { isVisible, animatedCardsRefs } = useAnimationAppearance({
		delay: 200,
		rootMargin: '80px',
	});
</script>

<template>
	<section class="problem-section">
		<h2 class="problem-section__title">Проблемы, которые мы решаем</h2>
		<div class="problem-section__list">
			<div
				:ref="(el) => (animatedCardsRefs[0] = el)"
				:class="{ 'is-visible': isVisible[0] }"
				class="problem-section__list-item"
			>
				<NuxtImg src="/images/svg/shield-off.svg" class="item-img" alt="" aria-hidden="true" />
				<h3 class="item-title">
					Отсутствие гарантий
					<br />
					от производителя
				</h3>
				<div class="item-br"></div>
				<div class="item-description">
					Работая через контракт агента, все вопросы по товару решает агент, вплоть до
					разбирательств в китайском суде
				</div>
			</div>

			<div
				:ref="(el) => (animatedCardsRefs[1] = el)"
				class="problem-section__list-item"
				:class="{ 'is-visible': isVisible[1] }"
			>
				<NuxtImg src="/images/svg/credit-card-x.svg" class="item-img" alt="" aria-hidden="true" />
				<h3 class="item-title">
					Проблемы с оплатой
					<br />
					в Китай
				</h3>
				<div class="item-br"></div>
				<div class="item-description">
					Все возникшие проблемы с оплатой и переводами решит своя компания в Китае
				</div>
			</div>

			<div
				:ref="(el) => (animatedCardsRefs[2] = el)"
				class="problem-section__list-item"
				:class="{ 'is-visible': isVisible[2] }"
			>
				<NuxtImg src="/images/svg/alert-triangle.svg" class="item-img" alt="" aria-hidden="true" />
				<h3 class="item-title">
					Риски
					<br />
					из-за санкций
				</h3>
				<div class="item-br"></div>
				<div class="item-description">
					Некоторые китайские производители рискуют поставлять товар напрямую. Нужна китайская
					компания-посредник
				</div>
			</div>
		</div>
		<NuxtImg
			src="/images/bg-plane.png"
			alt="Летящий самолет"
			densities="x1 x2"
			format="webp"
			sizes="360px xs:600px md:1200px xl:1200px"
			loading="lazy"
			class="bg-img"
		/>
	</section>
</template>

<style lang="scss" scoped>
	.problem-section {
		position: relative;
		width: 100%;
		padding: 35px 0px 68px;
		color: var(--color-white);
		background-color: var(--color-secondary);
		box-shadow: 100px 0px 0 0 var(--color-secondary), -100px 0px 0 0 var(--color-secondary);
	}
	.problem-section__title {
		font-size: var(--font-size-title);
		font-weight: 700;
		margin-bottom: 30px;
	}
	.problem-section__list {
		display: grid;
		grid-template-columns: 1fr;
		gap: 25px;
	}
	.problem-section__list-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		transition: transform ease-in 0.5s;
		transform: translateY(120px);
		&.is-visible {
			transform: translateY(0px);
		}
	}
	.item-img {
		width: 65px;
		height: 65px;
		margin-bottom: 15px;
	}
	.item-title {
		text-align: center;
		font-size: 20px;
		font-weight: 700;
		margin-bottom: 15px;
		text-wrap: balance;
		width: 228px;
		white-space: pre-wrap;
	}
	.item-br {
		width: 242px;
		height: 2px;
		background-color: var(--color-white);
		margin-bottom: 15px;
		transition: transform ease-in 0.5s;
	}
	.problem-section__list-item:hover .item-br {
		transform: scaleX(1.1);
	}
	.item-description {
		text-align: center;
		max-width: 400px;
	}
	.bg-img {
		position: absolute;
		content: '';
		bottom: 0px;
		transform: translateY(35%);
		object-position: 30%;
		object-fit: cover;
		width: 100%;
		-webkit-mask-image: linear-gradient(to right, black 60%, transparent 100%);
		mask-image: linear-gradient(to right, black 60%, transparent 100%);
	}

	@media (min-width: 600px) {
		.problem-section {
			padding: 35px 0px 110px;
		}
	}

	@media (min-width: 900px) {
		.problem-section {
			padding: 35px 0px 150px;
		}
	}

	@media (min-width: 1240px) {
		.problem-section {
			max-width: 1200px;
			padding: 60px 0px 170px;
			box-shadow: 1200px 0px 0 0 var(--color-secondary), 2400px 0px 0 0 var(--color-secondary),
				-1200px 0px 0 0 var(--color-secondary), -2400px 0px 0 0 var(--color-secondary);
		}
		.problem-section__list {
			grid-template-columns: 1fr 1fr 1fr;
			gap: 24px;
		}
		.problem-section__list-item {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		.item-img {
			width: 75px;
			height: 75px;
			margin-bottom: 17px;
		}
		.item-title {
			text-align: center;
			font-size: 22px;
			font-weight: 700;
			margin-bottom: 15px;
			text-wrap: balance;
			width: 232px;
			white-space: pre-wrap;
		}
		.item-description {
			text-align: center;
		}
		.bg-img {
			position: absolute;
			content: '';
			bottom: -200px;
			transform: translateY(0%);
			object-position: center;
			object-fit: cover;
			width: 1200px;
			-webkit-mask-image: linear-gradient(to right, black 50%, transparent 100%);
			mask-image: linear-gradient(to right, black 50%, transparent 100%);
		}
	}
</style>
